export default __webpack_public_path__ + "static/media/7.c3d78de3.svg";